import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/programs', label: 'Programs' },
    { path: '/training', label: 'Training' },
    { path: '/registration', label: 'Register' },
    { path: '/coaches', label: 'Coaches' },
    { path: '/results', label: 'Results' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/sponsorship', label: 'Sponsors' },
    { path: '/store', label: 'Store' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="network-header">
      <div className="network-header-container">
        <Link to="/" className="network-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_panthers-league/artifacts/h32tep3p_New%20Panthers%20Logo.jpg" 
            alt="Randallstown Panthers Logo" 
            className="logo-image"
          />
          <span className="logo-text">Randallstown Youth Football & Cheer</span>
        </Link>
        
        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Desktop Navigation */}
        <nav className="network-nav desktop-nav">
          {navLinks.map((link) => (
            <Link 
              key={link.path}
              to={link.path} 
              className={`network-nav-link ${isActive(link.path) ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="mobile-nav">
          {navLinks.map((link) => (
            <Link 
              key={link.path}
              to={link.path} 
              className={`mobile-nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Navigation;
